import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TAG_LIST } from '../../../constants/lists';
import { ActionButton } from '../';
import InfoTooltip from '../../InfoTooltip/Info-tooltip';
import TagElement from './TagElement';
import TagInput from './TagInput';
import { TagListProps } from './types';

export const TagList = ({
  className,
  isReadOnly = false,
  maxTags = 0,
  selectedTagList = [],
  setSelectedTagList,
  tagList = TAG_LIST,
  text = '',
}: TagListProps) => {
  const { t } = useTranslation();

  const [isTagInputActive, setIsTagInputActive] = useState(false);
  const [showTagTip, setShowTagTip] = useState(true);

  const tooltipContent = t('tooltips.tagList');

  const deleteTag = (tagToDelete: string) => {
    if (!isReadOnly && setSelectedTagList) {
      setSelectedTagList(selectedTagList.filter((tag) => tag !== tagToDelete));
    }
  };
  const addTag = (value: string) => {
    if (!isReadOnly) {
      value.trim() &&
        !selectedTagList.includes(value.trim()) &&
        setSelectedTagList?.([...selectedTagList, value.trim()]);
      showTagTip && setShowTagTip(false);
    }
  };

  return (
    <div
      className={`flex flex-wrap justify-center items-center gap-1 ${
        className || ''
      }`}
    >
      {tagList.slice(0, maxTags || tagList.length).map((tagName) => (
        <TagElement
          key={tagName}
          name={tagName}
          isReadOnly={isReadOnly}
          isSelected={false}
          isDisabled={selectedTagList.includes(tagName)}
          onTagClick={addTag}
        />
      ))}

      {maxTags && tagList.length > maxTags ? (
        <div className={'flex items-center font-semibold text-xs h-4 mr-2'}>
          {t('strategies.tags.more', { count: tagList.length - maxTags })}
        </div>
      ) : (
        <></>
      )}

      {/* List of tags */}
      {selectedTagList.map((tagName) => (
        <TagElement
          key={tagName}
          name={tagName}
          isSelected={true}
          onCloseClick={deleteTag}
        />
      ))}

      {!isReadOnly ? (
        <>
          {!isTagInputActive ? (
            <div className={'h-8.5 flex ml-3'}>
              <ActionButton
                onClick={() => setIsTagInputActive(true)}
                text={text || t('tagList.addTag')}
              />
            </div>
          ) : (
            <InfoTooltip
              content={tooltipContent}
              isTooltipVisible={showTagTip}
              isTooltipIconVisible
            >
              <TagInput
                onFinish={addTag}
                onCancel={() => setIsTagInputActive(false)}
              />
            </InfoTooltip>
          )}
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default TagList;
